import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Autosuggest from 'react-autosuggest'

import './AutocompleteGlossary.sass'


class AutocompleteGlossary extends Component {
  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: [],
      selectedTerm: null,
    }
  }

  componentDidMount() {
    window.addEventListener('click', this.clickOutsideTermPanel)
    window.addEventListener('touchstart', this.clickOutsideTermPanel)
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.clickOutsideTermPanel)
    window.removeEventListener('touchstart', this.clickOutsideTermPanel)
  }

  // Want to close panel when user clicks anywhere outside of panel
  clickOutsideTermPanel = e => {
    if (!this.state.selectedTerm || !this.selectedTermPanel || this.selectedTermPanel.contains(e.target)) { return }
    this.setState({ selectedTerm: null })
  }

  getSuggestionValue = suggestion => suggestion.term

  renderSuggestion = suggestion => <span>{suggestion.term}</span>

  renderInputComponent = inputProps => {
    return (
      <div className="autocomplete-glossary__search">
        <input
          type="search"
          {...inputProps}
          disabled={this.props.disabled}
          className="autocomplete-glossary__search-input"
        />
      </div>
    )
  }

  // Teach Autosuggest how to calculate suggestions for any given input value.
  getSuggestions = value => {
    const inputValue = value.trim().toLowerCase();

    if (inputValue.length === 0) {
      return []
    }

    return this.props.glossaryTerms.filter(suggestion => {
      return suggestion.term.toLowerCase().slice(0, inputValue.length) === inputValue
    })
  }

  onChange = (event, { newValue }) => {
    this.setState({ value: newValue, selectedTerm: null })
  }

  onSuggestionHighlighted = ({ suggestion }) => {
    // Hide term panel if keyboarding through options
    if (suggestion) {
      this.setState({ selectedTerm: null })
    }
  }

  onSuggestionSelected = (e, { suggestion: selectedTerm }) => {
    // Want to prevent this.clickOutsideTermPanel from being called
    e.nativeEvent.stopImmediatePropagation()
    this.setState({ selectedTerm })
  }

  // Autosuggest will call this function every time you need to update suggestions.
  // You already implemented this logic above, so just use it.
  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({ suggestions: this.getSuggestions(value) });
  }

  // Autosuggest will call this function every time you need to clear suggestions.
  onSuggestionsClearRequested = () => {
    this.setState({ suggestions: [] })
  }

  render() {
    const { value, suggestions, selectedTerm } = this.state
    const { placeholder, onSelect, glossaryTerms } = this.props

    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      placeholder: 'Need a definition?',
      value,
      onChange: this.onChange
    }

    return (
      <React.Fragment>
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          onSuggestionHighlighted={this.onSuggestionHighlighted}
          getSuggestionValue={this.getSuggestionValue}
          renderSuggestion={this.renderSuggestion}
          renderInputComponent={this.renderInputComponent}
          inputProps={inputProps}
          onSuggestionSelected={this.onSuggestionSelected}
        />
        {selectedTerm &&
          <div ref={el => this.selectedTermPanel = el} className="autocomplete-glossary__selected-panel react-autosuggest__suggestions-container--open">
            <div className="autocomplete-glossary__selected-term">{selectedTerm.term}</div>
            <div className="autocomplete-glossary__selected-definition">{selectedTerm.definition}</div>
          </div>
        }
      </React.Fragment>
    )
  }
}

AutocompleteGlossary.propTypes = {
  glossaryTerms: PropTypes.array
}

export default AutocompleteGlossary
